export interface EnquiryValues {
  name: string;
  email: string;
  phone: string;
  course: string;
  location: string;
  message: string;
  consent: boolean;
}

export type EnquiryErrors = Partial<Record<keyof EnquiryValues, string>>;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEnquiry(values: EnquiryValues): EnquiryErrors {
  const errors: EnquiryErrors = {};
  if (values.name.trim().length < 2) errors.name = 'Please write your name.';
  if (!EMAIL_PATTERN.test(values.email.trim())) errors.email = 'Please write a valid email address.';
  if (values.phone && values.phone.replace(/[^\d]/g, '').length < 7) {
    errors.phone = 'Please write the full number with the country code.';
  }
  if (!values.consent) errors.consent = 'Please agree so we can reply to you.';
  return errors;
}

// MOCKUP: replace with the real enquiry endpoint before launch.
export function sendEnquiry(values: EnquiryValues): Promise<void> {
  return new Promise((resolve, reject) => {
    window.setTimeout(() => {
      if (typeof navigator !== 'undefined' && !navigator.onLine) {
        reject(new Error('offline'));
        return;
      }
      if (!values.email) {
        reject(new Error('invalid'));
        return;
      }
      resolve();
    }, 900);
  });
}
